import { BulkActionWrapperDialogProps, BulkActionDialog } from 'components/core/bulk-actions/BulkActionDialog'
import { SearchUsers } from 'components/core/search/users'
import { AppValue } from 'lib/actions/apps'
import { AppSearchFilter } from 'pbts/c1/api/app/v1/app'
import { User, UserStatus } from 'pbts/c1/api/user/v1/user'
import { FC, useState } from 'react'
import { useIntl, FormattedMessage } from 'react-intl'

export const BulkAppAssignOwnersDialog: FC<BulkActionWrapperDialogProps<AppValue>> = (
    { close, selections, setSelections, triggerFetchActionStatus },
) => {
    const [users, setUsers] = useState<User[]>([])
    const intl = useIntl()
    const [userHelperTextError, setUserHelperTextError] = useState<string | undefined>(undefined)

    return (
        <BulkActionDialog<AppValue>
            close={close}
            args={{
                oneofKind: 'assignAppOwnersAction',
                assignAppOwnersAction: {
                    filter: AppSearchFilter.create({
                        ids: selections.map((app) => app.id),
                    }),
                    userIds: users.map((user) => user.id),
                } }}
            selections={selections}
            setSelections={setSelections}
            title={<FormattedMessage id="bulk_action_set_owners_title" defaultMessage="Set owners for {count} {count, plural, one {app} other {apps}}" values={{ count: selections.length }} />}
            description={<FormattedMessage id="bulk_action_set_owners_description" defaultMessage="Set new owners for the selected apps." />}
            submitButtonText={<FormattedMessage id="bulk_action_set_owners_submit" defaultMessage="Set owners" />}
            triggerFetchActionStatus={triggerFetchActionStatus}
        >
            <SearchUsers
                label={intl.formatMessage({
                    id: 'bulk_selected_set_app_owners_action_user_pick_label',
                    defaultMessage: 'Select new owners',
                })}
                autoFocus
                onSelected={(value): void => setUsers(value)}
                onBlur={(): void => {
                    if (users.length === 0) {
                        setUserHelperTextError(intl.formatMessage({
                            id: 'bulk_selected_set_app_owners_action_user_pick_helper_text',
                            defaultMessage: 'Select new owners',
                        }))
                    }
                }}
                onFocus={(): void => {
                    setUserHelperTextError(undefined)
                }}
                error={!!userHelperTextError}
                helperText={userHelperTextError}
                baseRequest={{
                    userStatuses: [UserStatus.ENABLED],
                }}
            />
        </BulkActionDialog>
    )
}
